// Image imports so Vite fingerprints + bundles them into /dist/assets/.
import uwiLogo from '../assets/img/uwi-logo.png';
// Full UWI Global Campus Climate Conference lockup (crest + wordmark + "Grenada 2027"),
// designed for light backgrounds. Used as the Help cover masthead.
import conferenceLogo from '../assets/img/uwigccc-logo.png';
import hero from '../assets/img/hero.jpg';
import asidePresenter from '../assets/img/aside-presenter.jpg';
import asideType from '../assets/img/aside-type.jpg';
import asideConsent from '../assets/img/aside-consent.jpg';
import asideAbstract from '../assets/img/aside-abstract.jpg';
import asideReview from '../assets/img/aside-review.jpg';
import strip1 from '../assets/img/strip-1.jpg';
import strip2 from '../assets/img/strip-2.jpg';
import strip3 from '../assets/img/strip-3.jpg';
import strip4 from '../assets/img/strip-4.jpg';
import successBg from '../assets/img/success-bg.jpg';

export const img = {
  uwiLogo,
  conferenceLogo,
  hero,
  asideConsent,
  asidePresenter,
  asideType,
  asideAbstract,
  asideReview,
  successBg,
  strip: [
    { src: strip1, label: "Saint George's, Grenada", credit: 'https://www.pexels.com/photo/12145125/' },
    { src: strip2, label: 'Grenada Harbour', credit: 'https://www.pexels.com/photo/4156554/' },
    { src: strip3, label: 'Caribbean Coast', credit: 'https://www.pexels.com/photo/10490921/' },
    { src: strip4, label: 'Caribbean Atmosphere', credit: 'https://www.pexels.com/photo/clouds-957925/' },
  ],
};
